import { func, number, objectOf, shape, string } from 'prop-types';
const errorsShape = objectOf(shape({
    ref: shape({ scrollIntoView: func, focus: func }),
    type: string,
    message: string,
})).isRequired;
const duplicateEntryShape = {
    errors: errorsShape,
};
const summaryBoxShape = duplicateEntryShape;
const errorSummaryShape = Object.assign(Object.assign({}, duplicateEntryShape), { errorsCount: number.isRequired });
export { duplicateEntryShape, summaryBoxShape, errorSummaryShape };
//# sourceMappingURL=competitions-form.js.map